import { useState } from "react";
import { toast } from "sonner";
import { AlertTriangle, Eye, Loader2, ScanText, Trash2 } from "lucide-react";
import { Uploader } from "@/components/PersonCard";
import { api, errMsg, openPdf } from "@/lib/api";

export function MenuUpload({ cid, data, setFields, editable }) {
  const [busy, setBusy] = useState(false);
  const [warnings, setWarnings] = useState([]);
  const files = data.a_menu_files || [];

  const upload = async (f) => {
    setBusy(true);
    const fd = new FormData();
    fd.append("file", f);
    try {
      const r = await api.post(`/contracts/${cid}/menu/upload`, fd);
      setFields({ ...r.data.fields, a_menu_files: r.data.files });
      setWarnings(r.data.warnings || []);
      const n = Object.keys(r.data.fields || {}).length;
      toast.success(n ? `Menù letto: ${n} voci compilate, verificale` : "Menù allegato");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const remove = async (fid) => {
    try {
      const r = await api.delete(`/contracts/${cid}/menu/files/${fid}`);
      setFields({ a_menu_files: r.data.files });
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <section className="rounded-xl border-2 border-dashed border-[#34B3B0] bg-[#EAF5F7]/60 p-5 sm:p-7 space-y-4 fade-up" data-testid="menu-upload-card">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h3 className="font-serif-it text-2xl font-semibold flex items-center gap-2"><ScanText size={20} className="text-[#0B6E8F]" /> {editable ? "Hai già il menù pronto?" : "Menù allegato in originale"}</h3>
          {editable && <p className="text-sm text-[#47606B] mt-1 max-w-xl">Fotografalo o carica il PDF: l'IA compila le portate qui sotto e il file resta allegato al contratto come parte dell'Allegato A.</p>}
        </div>
        {editable && <Uploader p="menu" busy={busy} onFile={upload} />}
      </div>
      {busy && <div className="flex items-center gap-2 text-sm text-[#075985] bg-[#E0F2FE] rounded-md p-3" data-testid="menu-reading"><Loader2 size={15} className="animate-spin" /> Lettura del menù in corso…</div>}
      {files.length > 0 && (
        <div className="flex flex-wrap gap-2" data-testid="menu-files">
          {files.map((f) => (
            <div key={f.id} className="flex items-center gap-2 text-xs rounded-full border border-[#D4E6EC] bg-white pl-3 pr-1 py-1">
              <span className="max-w-[200px] truncate">{f.name}</span>
              <button className="p-1 hover:bg-[#EAF5F7] rounded-full" onClick={() => openPdf(`/files/${f.id}/download`)} data-testid={`menu-file-open-${f.id}`}><Eye size={13} /></button>
              {editable && <button className="p-1 hover:bg-[#EAF5F7] rounded-full text-[#991B1B]" onClick={() => remove(f.id)} data-testid={`menu-file-remove-${f.id}`}><Trash2 size={13} /></button>}
            </div>
          ))}
        </div>
      )}
      {warnings.length > 0 && (
        <div className="rounded-md bg-[#FEF3C7] text-[#92400E] p-3 text-sm space-y-1" data-testid="menu-warnings">
          {warnings.map((w) => <div key={w} className="flex gap-2"><AlertTriangle size={15} className="shrink-0 mt-0.5" /> {w}</div>)}
        </div>
      )}
    </section>
  );
}
